import { createTheme } from '@one-thd/sui-atomic-components';

const MilwaukeePrimary = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

MilwaukeePrimary.palette['--sui-palette-background-primary'] = '229 25 55';

export { MilwaukeePrimary };
